import { PREFIX_URL } from '@/api/config';
import { axios } from '@/lib/axios/axios';

const url = `${PREFIX_URL}/accounts`;

export interface AccountManagerResponse {
  id: number | null;
  'full-name': string;
  avatar: string | null;
}

export interface AccountResponse {
  id: number;
  type: 'company' | 'project';
  name: string;
  manager: AccountManagerResponse;
  'inbox-email': string;
  'is-active': boolean;
  'can-manage': boolean;
}

export type AccountsScope = 'all' | 'assigned';

export interface GetAccountsResponse {
  scope: AccountsScope;
  accounts: AccountResponse[];
}

export const getAccounts = (): Promise<GetAccountsResponse> => axios.get(url);
